(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './reducer', './actions', './Feature'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./reducer'), require('./actions'), require('./Feature'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reducer, global.actions, global.Feature);
    global.index = mod.exports;
  }
})(this, function (exports, _reducer, _actions, _Feature) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.addFeatureFlags = exports.featureFlagsReducer = exports.ADD_FEATURE_FLAGS = undefined;
  Object.defineProperty(exports, 'ADD_FEATURE_FLAGS', {
    enumerable: true,
    get: function () {
      return _reducer.ADD_FEATURE_FLAGS;
    }
  });
  Object.defineProperty(exports, 'featureFlagsReducer', {
    enumerable: true,
    get: function () {
      return _reducer.featureFlagsReducer;
    }
  });
  Object.defineProperty(exports, 'addFeatureFlags', {
    enumerable: true,
    get: function () {
      return _actions.addFeatureFlags;
    }
  });

  var _Feature2 = _interopRequireDefault(_Feature);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Feature2.default;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-feature-flags/dist/index.js
// module id = ./node_modules/react-redux-feature-flags/dist/index.js
// module chunks = 0 1